import { useEffect, useState } from "react";

export function useNow(ms = 1000, offset = 0) {
  const [now, setNow] = useState(Date.now() + offset);
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now() + offset), ms);
    return () => clearInterval(t);
  }, [ms, offset]);
  return now;
}

export function countdown(targetIso, now) {
  const s = Math.max(0, Math.floor((new Date(targetIso).getTime() - now) / 1000));
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (d > 0) return `${d}d ${h}h ${m}m`;
  if (h > 0) return `${h}h ${m}m ${String(sec).padStart(2, "0")}s`;
  return `${m}:${String(sec).padStart(2, "0")}`;
}
